function FlashReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">FlashReport</div>
      </>
    );
  }
  
  export default FlashReport;